import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { CentroCustoSecundario } from "../../../../rh/domain/models/centro_custo_secundario";
import { IGetCentroCustoSecundariosUseCase } from "../../../presentation/useCases/read/get_centro_custo_secundarios_use_case";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


/**
 * GetCentroCustoSecundariosUseCase
 */

export class GetCentroCustoSecundariosUseCase extends BasePaginatedUseCase<CentroCustoSecundario> implements IGetCentroCustoSecundariosUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) {
    super();
  }

  async getCentroCustoSecundarios(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getCentroCustoSecundarios(idFuncionario, page, pageSize);

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}